module.exports = __webpack_public_path__ + "img/vilella-alt.6faa1a64.png";